import { CheckCircleIcon } from "@heroicons/react/24/outline";
import { useNavigate, useParams } from "@tanstack/react-router";

import Button from "@/components/form/Button";
import Modal from "@/components/layout/Modal";
import { useVideoGenerationStore } from "@/stores/videoGeneration.store";

export function VideoReadyModal() {
  const navigate = useNavigate();
  const params = useParams({ strict: false });
  const currentVideoId = (params as { videoId?: string }).videoId;

  const { completedVideoId, completedProjectName, clearCompleted } =
    useVideoGenerationStore();

  const isOpen =
    !!completedVideoId && completedVideoId !== currentVideoId;

  const handleGoToVideo = () => {
    if (completedVideoId) {
      void navigate({ to: "/v/$videoId", params: { videoId: completedVideoId } });
    }
    clearCompleted();
  };

  const handleDismiss = () => {
    clearCompleted();
  };

  return (
    <Modal
      isOpen={isOpen}
      setIsOpen={(v) => { if (!v) handleDismiss(); }}
      title="Film gotowy!"
    >
      <div className="flex flex-col items-center text-center py-4">
        <div className="rounded-full bg-accent/10 p-3 mb-4">
          <CheckCircleIcon className="size-8 text-accent" />
        </div>
        <p className="text-secondary mb-6">
          Twój film <strong>{completedProjectName}</strong> został wygenerowany i
          jest gotowy do obejrzenia.
        </p>
        <div className="grid grid-cols-2 gap-3 w-full">
          <Button variant="secondary" onClick={handleDismiss}>
            Zamknij
          </Button>
          <Button onClick={handleGoToVideo}>Przejdź do filmu</Button>
        </div>
      </div>
    </Modal>
  );
}
